export function savedQuotationId(body, existingId, expectedLines) {
    const result = body && body.results;
    const validWrite = write => write && write.error && Number(write.error.number) === 200;
    let valid = body && body.error && Number(body.error.number) === 200 && result;
    let id = Number(existingId);
    if (id > 0) {
        valid = valid && Array.isArray(result.x) && result.x.length > 0 &&
            result.x.every(write => write === true || validWrite(write));
    } else {
        id = Number(result && result.data);
        valid = valid && Number.isInteger(id) && id > 0 && validWrite(result.in) &&
            Number(result.in.results && result.in.results.newID) === id &&
            Array.isArray(result.DASF) && result.DASF.length === expectedLines && expectedLines > 0 &&
            result.DASF.every(write => validWrite(write) && Number(write.results && write.results.newID) > 0);
    }
    if (!valid) {
        const error = new Error('quotation_save_failed');
        error.response = { data: body };
        throw error;
    }
    return id;
}

export function quotationErrorMessage(error, arabic) {
    const body = error && error.response && error.response.data;
    const code = body && body.error && body.error.code;
    if (code === 'quotation_schema_not_ready') return arabic
        ? 'لم يتم حفظ عرض السعر. يلزم تحديث قاعدة البيانات.'
        : 'Quotation was not saved. The database needs its quotation update.';
    if (['quotation_input_invalid', 'quotation_line_invalid', 'quotation_totals_invalid'].includes(code)) return arabic
        ? 'لم يتم حفظ عرض السعر. تحقق من بيانات العميل والأصناف والإجماليات.'
        : 'Quotation was not saved. Check the customer, items and totals.';
    return arabic
        ? 'تعذر تأكيد حفظ عرض السعر. راجع قائمة عروض الأسعار قبل المحاولة مرة أخرى. تم الاحتفاظ بالبيانات المدخلة.'
        : 'Could not confirm the quotation was saved. Check the quotation list before retrying. Your entered details have been kept.';
}
